import React from 'react';
import Form from 'react-bootstrap/Form';
import { LinkButton } from 'common';
import '../../styles/commonPage.scss';

const ForgotCredentialsPage = () => {
  return (
    <div className="occu-form">
      <h5>Your Username is the email you provided to create your home loan application login.</h5>
      <Form>
        <LinkButton href="/mortgage/sign-in">Login</LinkButton>
        <LinkButton href="/mortgage/forgot-password">Reset My Password</LinkButton>
      </Form>
    </div>
  );
};

export default ForgotCredentialsPage;
